import styled, {css, DefaultTheme} from "styled-components"

export interface LabelProps {
  bold?: boolean
  error?: string
  flush?: boolean
  theme: DefaultTheme
}

export default styled.label<LabelProps>`
  ${({error, flush, theme}) => css`
    ${error && `color: ${theme.colors.tertiary.r_400}`};
    ${flush && "margin: 0"};
  `}
`
